import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext(null);

const useModal = () => useContext(ModalContext);

function ModalProvider({ children }) {
  const [toggleModal, setToggleModal] = useState(false);

  const showModal = show => {
    setToggleModal(show);
  };

  return (
    <ModalContext.Provider
      value={{
        toggleModal,
        letToggleModal: showModal
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}

export { useModal, ModalProvider };
